/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_LinuxInputs */

const en_cad_download_linux = /** @type {(inputs: Cad_Download_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linux`)
};

/**
* | output |
* | --- |
* | "Linux" |
*
* @param {Cad_Download_LinuxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_linux = /** @type {((inputs?: Cad_Download_LinuxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_LinuxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_linux(inputs)
});
export { cad_download_linux as "cad.download.linux" }